import Collapse from '@material-ui/core/Collapse/Collapse'
import Fade from '@material-ui/core/Fade/Fade'
import ListItem from '@material-ui/core/ListItem/ListItem'

import { useStyles } from './styles/RatePlansSelectionModalRow.styles'

interface RatePlansSelectionModalRowProps {
  selectedRateplan: string
  AdotelCode: string
  AdotelName: string
  ProviderName: string
  onClick: () => void
}
const RatePlansSelectionModalRow: React.FC<RatePlansSelectionModalRowProps> = ({
  selectedRateplan,
  AdotelCode,
  AdotelName,
  ProviderName,
  onClick
}) => {
  const classes = useStyles()
  return (
    <Collapse in={true} key={AdotelCode}>
      <ListItem
        button
        className={[
          classes.templateItem,
          selectedRateplan === AdotelCode ? classes.activeTemplateItem : ''
        ].join(' ')}
        onClick={onClick}>
        <Fade in={selectedRateplan === AdotelCode} timeout={250}>
          <span className={classes.activeCircle} />
        </Fade>
        {`${AdotelName} (${AdotelCode}) - ${ProviderName}`}
      </ListItem>
    </Collapse>
  )
}
export default RatePlansSelectionModalRow
